var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),(_vm.errors[_vm.name]!=undefined)?_c('strong',{staticClass:"small text-danger"},[_vm._v(" "+_vm._s(_vm.getError())+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }